export const videos = [
    {
        "id":0,
        "art":"Jiu-Jitsu",
        "profesor":"Martin Paz",
        "position":"Guard",
        "situation":"Takedown",
        "uniform ":"NOGI",
        "link": "https://www.youtube.com/watch?v=-ipl60m5eQA&list=PLPl81lqbj-4Kn-PRUvHuzh_591Euc3688",
        "image":"https://as1.ftcdn.net/v2/jpg/02/84/02/96/1000_F_284029685_nVVksdYixWGFP1PiYokqk03jtV3adDTH.jpg",
        "title":"Introduccion al takedown",
        "resume":"vamos a tirar con un seoi nague",
        "description":"en 1928, aprende a hacer esta tecnica",
        "likes":43
    },
    {
        "id":1,
        "art":"Jiu-Jitsu",
        "profesor":"Martin Paz",
        "position":"Guard",
        "situation":"Takedown",
        "uniform ":"NOGI",
        "link":"https://www.youtube.com/watch?v=-ipl60m5eQA&list=PLPl81lqbj-4Kn-PRUvHuzh_591Euc3688",
        "image":"https://as1.ftcdn.net/v2/jpg/02/84/02/96/1000_F_284029685_nVVksdYixWGFP1PiYokqk03jtV3adDTH.jpg",
        "title":"Introduccion al takedown",
        "resume":"vamos a tirar con un seoi nague",
        "description":"en 1928, aprende a hacer esta tecnica",
        "likes":43
    },
    {
        "id":2,
        "art":"Jiu-Jitsu",
        "profesor":"Martin Paz",
        "position":"Guard",
        "situation":"Takedown",
        "uniform ":"NOGI",
        "link":"https://www.youtube.com/watch?v=-ipl60m5eQA&list=PLPl81lqbj-4Kn-PRUvHuzh_591Euc3688",
        "image":"https://as1.ftcdn.net/v2/jpg/02/84/02/96/1000_F_284029685_nVVksdYixWGFP1PiYokqk03jtV3adDTH.jpg",
        "title":"Introduccion al takedown",
        "resume":"vamos a tirar con un seoi nague",
        "description":"en 1928, aprende a hacer esta tecnica",
        "likes":43
    },
    {
        "id":3,
        "art":"Jiu-Jitsu",
        "profesor":"Martin Paz",
        "position":"Guard",
        "situation":"Takedown",
        "uniform ":"NOGI",
        "link":"https://www.youtube.com/watch?v=-ipl60m5eQA&list=PLPl81lqbj-4Kn-PRUvHuzh_591Euc3688",
        "image":"https://as1.ftcdn.net/v2/jpg/02/84/02/96/1000_F_284029685_nVVksdYixWGFP1PiYokqk03jtV3adDTH.jpg",
        "title":"Introduccion al takedown",
        "resume":"vamos a tirar con un seoi nague",
        "description":"en 1928, aprende a hacer esta tecnica",
        "likes":43
    },
    {
        "id":4,
        "art":"Jiu-Jitsu",
        "profesor":"Martin Paz",
        "position":"Guard",
        "situation":"Takedown",
        "uniform ":"NOGI",
        "link":"https://www.youtube.com/watch?v=-ipl60m5eQA&list=PLPl81lqbj-4Kn-PRUvHuzh_591Euc3688",
        "image":"https://as1.ftcdn.net/v2/jpg/02/84/02/96/1000_F_284029685_nVVksdYixWGFP1PiYokqk03jtV3adDTH.jpg",
        "title":"Introduccion al takedown",
        "resume":"vamos a tirar con un seoi nague",
        "description":"en 1928, aprende a hacer esta tecnica",
        "likes":43
    },
    {
        "id":5,
        "art":"Jiu-Jitsu",
        "profesor":"Martin Paz",
        "position":"Guard",
        "situation":"Takedown",
        "uniform ":"NOGI",
        "link":"https://www.youtube.com/watch?v=-ipl60m5eQA&list=PLPl81lqbj-4Kn-PRUvHuzh_591Euc3688",
        "image":"https://as1.ftcdn.net/v2/jpg/02/84/02/96/1000_F_284029685_nVVksdYixWGFP1PiYokqk03jtV3adDTH.jpg",
        "title":"Introduccion al takedown",
        "resume":"vamos a tirar con un seoi nague",
        "description":"en 1928, aprende a hacer esta tecnica",
        "likes":43
    },
    {
        "id":6,
        "art":"Jiu-Jitsu",
        "profesor":"Martin Paz",
        "position":"Guard",
        "situation":"Takedown",
        "uniform ":"NOGI",
        "link":"https://www.youtube.com/watch?v=-ipl60m5eQA&list=PLPl81lqbj-4Kn-PRUvHuzh_591Euc3688",
        "image":"https://as1.ftcdn.net/v2/jpg/02/84/02/96/1000_F_284029685_nVVksdYixWGFP1PiYokqk03jtV3adDTH.jpg",
        "title":"Introduccion al takedown",
        "resume":"vamos a tirar con un seoi nague",
        "description":"en 1928, aprende a hacer esta tecnica",
        "likes":43
    },
    {
        "id":7,
        "art":"Jiu-Jitsu",
        "profesor":"Martin Paz",
        "position":"Guard",
        "situation":"Takedown",
        "uniform ":"NOGI",
        "link":"https://www.youtube.com/watch?v=-ipl60m5eQA&list=PLPl81lqbj-4Kn-PRUvHuzh_591Euc3688",
        "image":"https://as1.ftcdn.net/v2/jpg/02/84/02/96/1000_F_284029685_nVVksdYixWGFP1PiYokqk03jtV3adDTH.jpg",
        "title":"Introduccion al takedown",
        "resume":"vamos a tirar con un seoi nague",
        "description":"en 1928, aprende a hacer esta tecnica",
        "likes":43
    },
]
